<template>
  <GroupList :is-dialog="false"  />
</template>

<script>
import GroupList from "@/components/productInfo/GroupList.vue";

export default {
  name: "GoodsGroupManagement",
  components: {GroupList}
}
</script>

<style scoped>

</style>